import { useEffect, useCallback } from 'react';
import { useFetch, FetchParameterType, FetchStateType, FetchApiType } from './useFetch';
import { AddSubscriptionProductParameterType } from './useGetProductFromParent';

export const useGetOkAddSubscriptionFromParent = (
  productParameter: AddSubscriptionProductParameterType | undefined,
  token: string,
) => {
  const [addSubscriptionState, addSubscription] = 
    useFetch('addSubscriptionLineToFirstSubscription', token) as [FetchStateType, FetchApiType];

  const postAddSubscription = useCallback(async () => {

    if (!productParameter) return;
    if (!productParameter!.sellingPlanId || !productParameter!.variantId || !productParameter!.quantity ) return;

    const params: FetchParameterType = {
      planId: `gid://shopify/SellingPlan/${productParameter.sellingPlanId}`,
      variantId: `gid://shopify/ProductVariant/${productParameter.variantId}`,
      quantity: Number(productParameter.quantity),
    };

    await addSubscription(params);

  }, [productParameter, addSubscription]);

  useEffect(() => {
    const handleRecieveMessage = async (event: any) => {

      const { okAddSubscription } = event.data;

      if (typeof okAddSubscription !== 'boolean') return;
      if (okAddSubscription === false) return;

      postAddSubscription();
    };
    window.addEventListener('message', handleRecieveMessage);

    return () => window.removeEventListener('message', handleRecieveMessage);
  }, [postAddSubscription]);

  return addSubscriptionState;
};
